export default function initVideoWall() {
  const regionFilter = document.querySelector('.js-filter-select-region-area');
  if (regionFilter) {
    // Show select field column
    regionFilter.parentElement.classList.remove('d-none');
    // Check/uncheck matching hidden checkboxes
    regionFilter.addEventListener('change', (ev) => {
      const field = ev.target;
      const regionArea = field.value;
      const form = field.form;
      const regionCheckboxes = form.querySelectorAll(
        '.js-filter-checkbox-region'
      );
      [...regionCheckboxes].forEach((checkbox) => {
        checkbox.checked = false;
      });
      // All regions - deselect all to clear filters
      if (regionArea !== '') {
        const regionAreaCheckboxes = [...regionCheckboxes].filter(
          (checkbox) => checkbox.dataset.regionArea === regionArea
        );
        regionAreaCheckboxes.forEach((checkbox) => {
          checkbox.checked = true;
        });
      }
    });
  }
}
